/** biome-ignore-all lint/suspicious/noExplicitAny: <any is allowed> */
const isDev = import.meta.env.DEV;

export const API = isDev
	? "http://localhost:3000"
	: "https://www.ai-checker-for-teachers.com";

const STORAGE_KEY = "ai-checker-uuid";

interface PostOptions {
	headers?: Record<string, string>;
}

async function getUserId(): Promise<string> {
	if (
		typeof chrome !== "undefined" &&
		chrome.runtime &&
		chrome.runtime.sendMessage
	) {
		return new Promise<string>((resolve, reject) => {
			chrome.runtime.sendMessage({ type: "GET_UUID" }, (response) => {
				// console.log("UUID from background:", response);
				if (!response?.uuid) {
					reject(new Error("UUID not found"));
				} else {
					resolve(response.uuid);
				}
			});
		});
	} else if (isDev) {
		return "dev";
	} else {
		// For none extension usage, get or create user ID from web localStorage
		try {
			let userId = localStorage.getItem(STORAGE_KEY);
			if (!userId) {
				userId = crypto.randomUUID();
				localStorage.setItem(STORAGE_KEY, userId);
			}
			return userId;
		} catch {
			throw new Error("localStorage not available");
		}
	}
}

export async function post<T = any>(
	endPoint: string,
	data: any,
	options: PostOptions = {},
): Promise<T> {
	let userId: string;
	let response: Response;

	try {
		userId = await getUserId();
		response = await fetch(`${API}/api/${endPoint}`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				...options.headers,
			},
			body: JSON.stringify({ ...data, userId }),
		});

		if (!response.ok) {
			const errorData = await response.json();
			// console.error("Error in post request:", errorData);
			const error = new Error(errorData.error || response.statusText);
			(error as any).message = errorData.error;
			(error as any).status = response.status;
			throw error;
		}
	} catch (error) {
		console.error("Error in post request:", error);
		throw error;
	}

	return response.json();
}
